export default {
      id: "eld_clock-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "img/icons.svg#eld_clock",
      toString: function () {
        return this.url;
      }
    }